import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Team } from '../../../clients'

type TeamStoreType = Omit<Team, 'createdAt' | 'updatedAt'> & { createdAt: string, updatedAt: string }

interface AlertsState {
    teams: TeamStoreType[]
}

const initialState: AlertsState = {
    teams: []
}

const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {
        setTeams(state, payload: PayloadAction<TeamStoreType[]>) {
            state.teams = payload.payload
        },
        addTeam(state, payload: PayloadAction<TeamStoreType>) {
            state.teams.push(payload.payload)
        },
        updateTeam(state, payload: PayloadAction<TeamStoreType>) {
            const index = state.teams.findIndex(x => x.id === payload.payload.id)
            state.teams[index] = payload.payload
        },
    }
})

export const { setTeams, addTeam, updateTeam } = teamsSlice.actions
export default teamsSlice.reducer